export class S3Buckets {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "buckets",
            "baseName": "buckets",
            "type": "Array<S3Bucket>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3Buckets.attributeTypeMap;
    }
    constructor() {
    }
}
